import { Actions } from '../actions/actions';
import { Menu } from '../models/menu';
import { MenuActionTypes } from '@uxdf/direct-shared-lib';

export interface State {
  isLoading: boolean;
  menuList: Menu;
}

/* eslint-disable */
function getInitialState(): State {
  return {
    isLoading: true,
    menuList: {} as Menu
  };
}

const initialState: State = getInitialState();

/* eslint-disable */
export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case MenuActionTypes.InitGuestMenuList: {
      return { ...getInitialState(), isLoading: true };
    }

    case MenuActionTypes.SetMenuList: {
      return { ...state, isLoading: false, menuList: action.payload.menuList };
    }

    default:
      return state;
  }
}
